import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { usePanelAccess } from '../../context/PanelAccessContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../core/store/store';
import {
  canPanelModeratePlayers,
  canPanelAdminTier,
} from '../../panelAccess/panelRoleAccess';

const PanelLogsPage: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { hasAccessToSection, loading } = usePanelAccess();
  const location = useLocation();
  const roleId = currentUser?.roles_id ?? 0;

  if (loading || !currentUser) return null;

  const tabs = [
    {
      to: '/panel/logs/synthese',
      can: hasAccessToSection('salon_security') || canPanelModeratePlayers(roleId),
    },
    {
      to: '/panel/logs/complet',
      can: hasAccessToSection('salon_security') || canPanelAdminTier(roleId),
    },
  ];

  const visibleTabs = tabs.filter((t) => t.can);
  if (!visibleTabs.length) return <Navigate to="/panel/dashboard" replace />;

  if (location.pathname === '/panel/logs' || location.pathname === '/panel/logs/') {
    return <Navigate to={visibleTabs[0].to} replace />;
  }

  return <Outlet />;
};

export default PanelLogsPage;
